'use strict';

wbApp.factory('tenantInfoSvc', [
    function () {
        var data = tenantInfo;

        return {
            info: data
        }
    }]);